<template>
  <div id="app">
    <div id="content">
      <app-header></app-header>
      <router-view/>
    </div>
    <app-footer></app-footer>
  </div>
</template>
<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
export default {
  name: 'App',
  components: {
    AppHeader,
    AppFooter
  }
}
</script>

<style lang="scss">
*{
  margin: 0;
  padding: 0;
}
  #app {
    min-height: 100vh;
    //background: black;
    background-image: url('assets/img/what-the-hex-dark.png');
    background-position: center;
    background-repeat: repeat;
    display: flex;
    flex-direction: column;
  }

#content {
    flex:1;
}

  @font-face {
    font-family: 'Tarrget Academy';
    src: url('../src/assets/fonts/hinted-TarrgetAcademyItalic.woff2') format('woff2'),
        url('../src/assets/fonts/hinted-TarrgetAcademyItalic.woff') format('woff'),
        url('../src/assets/fonts/tarrgetacadital.ttf')format('ttf'),
        url('../src/assets/fonts/hinted-TarrgetAcademyItalic.svg#TarrgetAcademyItalic') format('svg');
    font-weight: normal;
    font-style: italic;
}

@font-face {
    font-family: 'Tarrget Platinum';
    src: url('../src/assets/fonts/hinted-TarrgetPlatinum.woff2') format('woff2'),
        url('../src/assets/fonts/hinted-TarrgetPlatinum.woff') format('woff'),
        url('../src/assets/fonts/tarrgetplat.ttf')format('ttf'),
        url('../src/assets/fonts/hinted-TarrgetPlatinum.svg#TarrgetPlatinum') format('svg');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'Tarrget Laser';
    src: url('../src/assets/fonts/hinted-TarrgetLaser.woff2') format('woff2'),
        url('../src/assets/fonts/hinted-TarrgetLaser.woff') format('woff'),
        url('../src/assets/fonts/tarrgetlaser.ttf')format('ttf'),
        url('../src/assets/fonts/hinted-TarrgetLaser.svg#TarrgetLaser') format('svg');
    font-weight: normal;
    font-style: normal;
}
</style>
